// src/features/dev/devSlice.ts
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

type MockState = 'filled' | 'empty' | 'loading' | 'error'
type PlayerProgressState = 'empty' | 'partial' | 'completed' | 'loading' | 'error'

export interface DevState {
  pastedJwt: string
  useMockAuth: boolean
  forceIsAdmin: boolean
  forceIsAuthor: boolean
  networkLatencyMs: number
  mockStates: {
    favorites: MockState
    playerProgress: PlayerProgressState
  }
}

const initialState: DevState = {
  pastedJwt: '',
  useMockAuth: false,
  forceIsAdmin: false,
  forceIsAuthor: false,
  networkLatencyMs: 300,
  mockStates: {
    favorites: 'filled',
    playerProgress: 'empty',
  },
}

export const devSlice = createSlice({
  name: 'dev',
  initialState,
  reducers: {
    setPastedJwt: (state, action: PayloadAction<string>) => {
      state.pastedJwt = action.payload
    },
    setUseMockAuth: (state, action: PayloadAction<boolean>) => {
      state.useMockAuth = action.payload
    },
    setForceIsAdmin: (state, action: PayloadAction<boolean>) => {
      state.forceIsAdmin = action.payload
    },
    setForceIsAuthor: (state, action: PayloadAction<boolean>) => {
      state.forceIsAuthor = action.payload
    },
    setNetworkLatency: (state, action: PayloadAction<number>) => {
      state.networkLatencyMs = action.payload
    },
    setMockState: <K extends keyof DevState['mockStates']>(
      state: DevState,
      action: PayloadAction<{ key: K; value: DevState['mockStates'][K] }>,
    ) => {
      state.mockStates[action.payload.key] = action.payload.value
    },
    resetDevState: () => initialState,
  },
})

export const {
  setPastedJwt,
  setUseMockAuth,
  setForceIsAdmin,
  setForceIsAuthor,
  setNetworkLatency,
  setMockState,
  resetDevState,
} = devSlice.actions
export const devReducer = devSlice.reducer
